module.exports = __webpack_public_path__ + "img/opera.ec4b5df9.png";